module.exports = __webpack_public_path__ + "img/Img.vision.ca85b6ef.svg";